"use client";

import {
  Box,
  Paper,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import { FileUploadField } from "./file-upload-field";
import { EmzaDrawer } from "./emza-drawer";
import { LetterheadSelector } from "./letterhead-selector";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "../../utils/convertToJalali";
import jalaliday from "jalaliday";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import jalaali from "jalaali-js";

dayjs.extend(jalaliday);

export function AddLetterForm({
  formData,
  onChange,
  onFileChange,
  onOpenEmzaDrawer,
  onOpenLetterheadDrawer,
  onSelectEmza,
  onSelectLetterhead,
  onCloseEmzaDrawer,
  onCloseLetterheadDrawer,
  emzaDrawerOpen,
  letterheadDrawerOpen,
  currentUserId,
}) {
  const handleChange = (field) => (event) => {
    onChange(field, event.target.value);
  };

  const handleCheckboxChange = (field) => (event) => {
    onChange(field, event.target.checked);
  };

 

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        bgcolor: "#f5f5f5",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          p: 1,
          bgcolor: "white",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          gap: { xs: 2, md: 4 },
        }}
      >
        {/* Header Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column-reverse", sm: "row" },
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", sm: "250px" },
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
            }}
          >
            {/* Letterhead Selector */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Button
                variant="outlined"
                size="small"
                onClick={onOpenLetterheadDrawer}
                sx={{ textTransform: "none" }}
              >
                {formData.idsarbarg ? "تغییر سربرگ" : "انتخاب سربرگ"}
              </Button>
            </Box>

            {/* Date Picker Section */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" sx={{ minWidth: "60px" }}>
                تاریخ:
              </Typography>

              {/* 4. Use AdapterDateFnsJalali here */}
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fa">
                <DatePicker
                  format="YYYY/MM/DD"
                  value={
                    formData.dateletter
                      ? dayjs(formData.dateletter).calendar("jalali")
                      : null
                  }
                  onChange={(newValue) => {
                    if (newValue && dayjs.isDayjs(newValue)) {
                      try {
                        // Convert to Jalali calendar mode and format as string
                        const jalaliDate = newValue.calendar("jalali");
                        const jalaliStr = jalaliDate.format("YYYY/MM/DD");
                        
                        // Parse the Jalali date string
                        const [jalaliYear, jalaliMonth, jalaliDay] = jalaliStr.split("/").map(Number);
                        
                        // Convert Jalali to Gregorian using jalaali-js
                        const gregorian = jalaali.toGregorian(jalaliYear, jalaliMonth, jalaliDay);
                        
                        // Create ISO string from Gregorian date (set time to midnight UTC)
                        const date = new Date(Date.UTC(
                          gregorian.gy,
                          gregorian.gm - 1, // JavaScript months are 0-indexed
                          gregorian.gd,
                          0, 0, 0, 0
                        ));
                        const isoString = date.toISOString();
                        
                        onChange("dateletter", isoString);
                      } catch (error) {
                        console.error("Error converting Jalali date:", error);
                        // Fallback: use the date as-is (assuming it's already Gregorian)
                        const isoString = newValue.toISOString();
                        onChange("dateletter", isoString);
                      }
                    } else {
                      onChange("dateletter", "");
                    }
                  }}
                  slotProps={{
                    textField: { size: "small", variant: "standard" },
                  }}
                />
              </LocalizationProvider>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" sx={{ minWidth: "60px" }}>
                شماره:
              </Typography>
              <TextField
                variant="standard"
                size="small"
                fullWidth
                value={formData.numletter || ""}
                onChange={handleChange("numletter")}
                placeholder="---"
              />
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" sx={{ minWidth: "60px" }}>
                پیوست:
              </Typography>
              <Box
                sx={{ display: "flex", alignItems: "center", flex: 1, gap: 1 }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.isattach || false}
                      onChange={handleCheckboxChange("isattach")}
                      size="small"
                      sx={{ p: 0.5 }}
                    />
                  }
                  label={formData.isattach ? "دارد" : "ندارد"}
                  sx={{
                    m: 0,
                    "& .MuiTypography-root": { fontSize: "0.875rem" },
                  }}
                />
                {formData.isattach && (
                  <TextField
                    variant="standard"
                    size="small"
                    fullWidth
                    placeholder="شماره/تعداد"
                    value={formData.attachmentNum || ""}
                    onChange={handleChange("attachmentNum")}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Sender & Receiver */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "start", sm: "center" },
              gap: { xs: 1, sm: 2 },
            }}
          >
            <Typography>از:</Typography>
            <TextField
              variant="standard"
              fullWidth
              value={formData.sender || ""}
              onChange={handleChange("sender")}
              placeholder="نام فرستنده"
              InputProps={{ style: { fontSize: "1rem" } }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "start", sm: "center" },
              gap: { xs: 1, sm: 2 },
            }}
          >
            <Typography>به:</Typography>
            <TextField
              variant="standard"
              fullWidth
              value={formData.receiver || ""}
              onChange={handleChange("receiver")}
              placeholder="نام گیرنده"
              InputProps={{ style: { fontSize: "1rem" } }}
            />
          </Box>
        </Box>

        {/* Title */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "start", sm: "center" },
            gap: { xs: 1, sm: 2 },
          }}
        >
          <Typography>موضوع:</Typography>
          <TextField
            variant="standard"
            fullWidth
            value={formData.title || ""}
            onChange={handleChange("title")}
            placeholder="عنوان نامه را وارد کنید"
            InputProps={{ style: { fontSize: "1rem" } }}
          />
        </Box>

        {/* Body Text */}
        <Box sx={{ flexGrow: 1, my: 1 }}>
          <TextField
            multiline
            fullWidth
            variant="standard"
            value={formData.textletter || ""}
            onChange={handleChange("textletter")}
            placeholder="متن نامه ..."
            sx={{
              "& .MuiInputBase-root": {
                lineHeight: 2.5,
                textAlign: "justify",
                fontSize: "1rem",
              },
            }}
          />
        </Box>

        {/* Post Script (Roonevesht) */}
        <Box sx={{ flexGrow: 1, my: 1 }}>
          <TextField
            multiline
            fullWidth
            variant="standard"
            value={formData.roonevesht || ""}
            onChange={handleChange("roonevesht")}
            placeholder="رونوشت"
            sx={{
              "& .MuiInputBase-root": {
                lineHeight: 2.5,
                textAlign: "justify",
                fontSize: "1rem",
              },
            }}
          />
        </Box>

        {/* Signature Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <TextField
              variant="standard"
              value={formData.fullname || ""}
              onChange={handleChange("fullname")}
              placeholder="نام و نام خانوادگی"
              inputProps={{
                style: { textAlign: "center" },
              }}
            />
            <TextField
              variant="standard"
              value={formData.postName || ""}
              onChange={handleChange("postName")}
              placeholder="سمت / عنوان شغلی"
              inputProps={{ style: { textAlign: "center" } }}
            />
            <Button
              variant="outlined"
              size="small"
              onClick={onOpenEmzaDrawer}
              sx={{ textTransform: "none", mt: 2 }}
            >
              {formData.idemza ? "تغییر امضا" : "انتخاب امضا"}
            </Button>
          </Box>
        </Box>
      </Paper>

      {/* Emza Drawer */}
      {emzaDrawerOpen && (
        <EmzaDrawer
          selectedLetterhead={formData.idemza}
          onSelect={(id) => {
            if (id !== null && id !== undefined) {
              onSelectEmza(id);
            }
          }}
          onClose={onCloseEmzaDrawer}
          currentUserId={currentUserId}
        />
      )}

      {/* Letterhead Drawer */}
      {letterheadDrawerOpen && (
        <LetterheadSelector
          selectedLetterhead={formData.idsarbarg}
          onSelect={(id) => {
            if (id !== null && id !== undefined) {
              onSelectLetterhead(id);
            }
          }}
          onClose={onCloseLetterheadDrawer}
          currentUserId={currentUserId}
        />
      )}
    </Box>
  );
}
